export default __webpack_public_path__ + "static/media/ready_sound.5b8edab8.wav";